import { useStore } from '../../../../contexts/StoreContext';
import { DynamicModalProps } from '../DynamicModal.types';
import { useCallback, useEffect, useMemo } from 'react';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';

export const useModalMaxProductsAlertLogic = ({
  dynamicModalVisible,
  dynamicModalLayer: { productLimit },
}: DynamicModalProps) => {
  const {
    project: { activeProject, switchToGroup },
    dynamicModal: { closeModal },
  } = useStore();

  const amplitudeData = useMemo(() => {
    const firstGroupWithMissingProducts = activeProject?.groups.find(group => group.isMissingMaxProducts)!;
    return {
      missing_products_count: productLimit - firstGroupWithMissingProducts.products.length,
      product_group: firstGroupWithMissingProducts.code,
    };
  }, [productLimit, activeProject?.groups]);

  useEffect(() => {
    if (dynamicModalVisible) {
      amplitude.trackEvent(AnalyticsEvents.personalize.maximumQuantityAlertView, amplitudeData);
    }
  }, [dynamicModalVisible, amplitudeData]);

  const onCloseModal = useCallback(async () => {
    amplitude.trackEvent(AnalyticsEvents.personalize.maximumQuantityAlertClick, {
      action: 'close_modal',
      ...amplitudeData,
    });
    closeModal();
  }, [amplitudeData]);

  const onBackPress = useCallback(async () => {
    const firstGroupWithMissingProducts = activeProject?.groups.find(group => group.isMissingMaxProducts)!;
    switchToGroup({
      groupId: firstGroupWithMissingProducts.id,
      scrollTo: 'top',
      forceOpening: true,
    });
    amplitude.trackEvent(AnalyticsEvents.personalize.maximumQuantityAlertClick, {
      action: 'back_pressed',
      ...amplitudeData,
    });
    closeModal();
  }, [activeProject?.groups, amplitudeData]);

  return {
    onCloseModal,
    onBackPress,
  };
};
